import { render, staticRenderFns } from "./ModalPaymentNotifications.vue?vue&type=template&id=0ee4650e&scoped=true"
import script from "./ModalPaymentNotifications.vue?vue&type=script&lang=js"
export * from "./ModalPaymentNotifications.vue?vue&type=script&lang=js"
import style0 from "./ModalPaymentNotifications.vue?vue&type=style&index=0&id=0ee4650e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ee4650e",
  null
  
)

export default component.exports